import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const verifyAddressMutation = gql`
  mutation verifyAddress(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $state: VerifyAddressState!
    $startDate: String
    $weeksNotice: Int
    $numberOfTimesLate: Int
  ) {
    verifyAddress(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      state: $state
      startDate: $startDate
      weeksNotice: $weeksNotice
      numberOfTimesLate: $numberOfTimesLate
    )
  }
`

export enum VerifiedState {
  verifiedByDocumentsAndAst = 'verifiedByDocumentsAndAst',
}

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  state: VerifiedState
  startDate: string
  weeksNotice: number
  numberOfTimesLate: number
}

export type VerifyData = {
  verifyAddress: string | unknown
}

export const useVerifyAddressMutation: WrappedMutation<VerifyData, MutationVars> = () =>
  useMutation<VerifyData, MutationVars>(verifyAddressMutation, {
    client: agentClient,
  })
